import NotificationService from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/services/NotificationService";
import { traceo } from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/utils/Logging";
import { EnsolversOpsUser } from "../models/EnsolversOpsUser";
import OpsImageService from "../services/OpsImageService";
import OpsUserService from "../services/OpsUserService";

interface UseUserAvatarProps {
  userAvatarUpdate: EnsolversOpsUser | undefined;
  setIsLoading: (value: boolean) => void;
  setUserAvatarUpdate: (value: EnsolversOpsUser | undefined) => void;
  setUser: (value: EnsolversOpsUser | undefined) => void;
}

const useUserAvatar = ({ userAvatarUpdate, setIsLoading, setUserAvatarUpdate, setUser }: UseUserAvatarProps) => {
  const handleSaveAvatar = async (response: any) => {
    setIsLoading(true);
    if (response.file) {
      const fileName: string = `ensolvers-ops-avatar_${userAvatarUpdate!.externalId}`;
      try {
        const uploadImageResult = await OpsImageService.uploadImage(response.file, fileName);
        const avatarUrl = uploadImageResult.getContentOrThrowError().url;
        const updaterUser: EnsolversOpsUser = {
          ...userAvatarUpdate,
          avatarUrl,
        };
        await OpsUserService.update(updaterUser);
        setUser(updaterUser);
        NotificationService.info("Avatar uploaded!");
      } catch (error) {
        traceo("Error uploading avatar", error, null);
        NotificationService.error("Error uploading avatar!");
      }
      setIsLoading(false);
    }
    setUserAvatarUpdate(undefined);
  };

  const handleCancel = () => {
    setUserAvatarUpdate(undefined);
  };

  return {
    handleSaveAvatar,
    handleCancel,
  };
};

export default useUserAvatar;
